import { put, takeEvery, all } from 'redux-saga/effects';
import * as constants from '../constants/video';
import * as videoPageActions from '../actions/video';
import * as coreActions from '../actions/core';
import { SecurityContextType, MessageState } from '../../models/components/announcement.d';
import { Log } from 'ng2-logger';
import { Common } from '../../core/common';
import { VideoService } from '../../api/video-service';
import { Notification } from '../../components/notification/main';
import Translator from '../../core/i18n';
const T = Translator.create();
const _logger = Log.create('video Saga');
const _videoService = new VideoService();

//#region "Add Video Activity Saga"
function* setAddVideoActivity(params: any): any {
    let isError = false;
    let errorList: any;

    try {
        const requestReturn = yield _videoService.RequestAddVideoActivityAsync(params.videoData)
            .then((responseData: Response) => {
                return responseData;
            }).then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    return response;
                }
            });

        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
            if (params.callback) {
                params.callback(null);
            }
        }

        if (!isError) {
            const _params: any = { questions: params.questionData.questions, activityId: requestReturn, callback: params.callback };
            const redirectPageParams: any = {
                submitValues: params.videoData,
                activityId: params.videoData.projectActivityId ? params.videoData.projectActivityId : params.videoData.activityId ? params.videoData.activityId : requestReturn,

                termWeekId:
                    params.videoData.termWeekIds && params.videoData.termWeekIds[0] !== '0'
                        ? params.videoData.termWeekIds[0]
                        : params.videoData.termWeekIds[1]
            };
            yield setAddOrUpdateQuestionVideo(_params, redirectPageParams, params.spinnerId);
            yield put(coreActions.newNotification(T.t('r_add_activity_succesful_notification'), '', '', 'topRight', 'success'));
        }
    } catch (error: any) {
        // catch error!
        yield put(coreActions.newNotification(T.t('r_request_error_on_video_add'), '', '', 'topRight', 'error'));
        yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        if (params.callback) {
            params.callback(null);
        }
    }
}

function* setAddOrUpdateQuestionVideo(params: any, redirectPageParams?: any, spinnerId?: string): any {
    let isError: boolean = false;
    let errorList: any;
    try {
        const requestReturn = yield _videoService.RequestAddOrUpdateQuestionVideoAsync(params)
            .then((responseData: Response) => {
                return responseData;
            }).then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                }
            });
        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        } else {
            yield put(videoPageActions.setVideoQuestionDataDefault());
            params.callback(redirectPageParams);
        }
    } catch (error: any) {
        yield put(coreActions.setSpinner(params.spinnerId, 'set'));
    }
}

function* setVideoData(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        const requestReturn = yield _videoService.RequestGetVideoAsync({ ...params, take: 20, skip: 0 })
            .then((response: Response) => {
                return response;
            })
            .then((response: Response) => {
                if (response.status !== 200) {
                    isError = true;
                }
                return response.json();
            })
            .then((responseData: any) => {
                if (isError) {
                    errorList = responseData;
                } else {
                    return responseData;
                }
            })
            .then((data: any | null) => {
                if (!data) {
                    return null;
                } else {
                    return data;
                }
            });
        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : yield put(coreActions.newNotification(T.t('r_request_error_on_video_activity_get'), '', '', 'topRight', 'error'));
            return false;
        }

        if (!isError) {
            yield put(videoPageActions.setVideoData(requestReturn[0], params.spinnerId, 'set'));
            return true;
        }
    } catch (error: any) {
        // catch error!
        yield put(coreActions.newNotification(T.t('r_request_error_on_video_activity_get'), '', '', 'topRight', 'error'));
        return false;
    }
}



export function* watchGetAddVideoData() {
    yield takeEvery(constants.actions.GET_ADD_VIDEO_DATA, setAddVideoActivity);
    return null;
}

export function* watchGetAddOrUpdateQuestionData() {
    yield takeEvery(constants.actions.SET_ADD_VIDEO_QUESTION_DATA, setAddOrUpdateQuestionVideo);
    return null;
}

export function* watchGetVideoData() {
    yield takeEvery(constants.actions.GET_VIDEO_DATA, setVideoData);
    return null;
}

//#endregion "Add Video Activity End Saga"

export function* VideoSagas() {
    yield all([
        watchGetAddVideoData(),
        watchGetAddOrUpdateQuestionData(),
        watchGetVideoData()
    ]);
}